export const convertToFahrenheit = (value) => {
  return value * (9 / 5) + 32;
};
